/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'

import {
  SvgIcon,
  FilterSidebar,
  Downloads,
  PicklistWithData
} from '../components'

class DownloadList extends React.Component {
  state = {
    languageFilter: null,
    search: '',
    orderBy: 'name'
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search) {
      this.setFiltersFromQueryString(nextProps.location.search)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.location.search === '' &&
      (nextState.languageFilter !== '' ||
      nextState.orderBy !== '')) {
      this.setQueryString(nextState)
      return false
    }
    else if (Object.is(this.props.location.search, nextProps.location.search) && (
      this.state.languageFilter !== nextState.languageFilter ||
      this.state.orderBy !== nextState.orderBy)) {
      this.setQueryString(nextState)
      return false
    }
    else if (this.state.search !== nextState.search ||
      this.state.languageFilter !== nextState.languageFilter ||
      this.state.orderBy !== nextState.orderBy) {
      this.setQueryString(nextState)
      return false
    }

    return true
  }

  componentDidMount = () => {
    // this life-cycle function implementation ensures that, on first render and/or
    // returning from another page, that filters will still be set to url and what it was before
    if (this.props.location.search) {
      this.setFiltersFromQueryString(this.props.location.search)
    } else {
      this.setQueryString(this.state)
    }
  }

  setFiltersFromQueryString = (queryString) => {
    let queryParams = qs.parse(queryString)

    let filters = Object.assign(
      {},
      ...Object.keys(queryParams).map(key => (  // ES6 way of assigning renamed object keys
        [ 'search', 'orderBy' ].indexOf(key) > -1
          ? { [key]: queryParams[key] }
          : { [`${key}Filter`]: queryParams[key] }
      ))
    )
    this.setState(filters)
  }

  setQueryString = (state) => {
    let filters = {
      orderBy: state.orderBy
    }

    if (state.languageFilter) {
      filters.language = state.languageFilter
    }

    if (state.search !== '') {
      filters.search = state.search
    }

    this.props.history.push({
      pathname: '/os/downloads',
      search: qs.stringify(filters)
    })
  }

  handleFilterChange = (language) => {
    this.setState({ languageFilter: language === 'all' ? null : language })
  }
  handleFilterClear = () => this.setState({ languageFilter: null })

  handleSearchClick = (search) => this.setState({ search })
  handleSearchClear = () => this.setState({ search: '' })

  handleSortChange = (orderBy) => this.setState({ orderBy })

  getNumberOfFiltersApplied = () => (
    this.state.languageFilter !== null ? 1 : null
  )

  render() {
    let filters = [
      {
        title: 'Language',
        options: <PicklistWithData
          id='language'
          forField='FileTypeLanguage'
          default='All'
          symbol='chevrondown'
          value={this.state.languageFilter || ''}
          onChange={this.handleFilterChange}
          closeDropdownOnSelect={true}
          inline={true}
        />
      }
    ]

    let numberOfFiltersApplied = this.getNumberOfFiltersApplied()

    return (
      <div className='slds-grow slds-scrollable_y' role='main'>
        <div className='slds-grid slds-wrap slds-size_1-of-1'>
          <div className='tab-nav slds-size_1-of-1 u-bg-color-white product-listing-page-header'>
            <div className='u-font-size-x-large u-text-caps slds-p-left_small product-listing-page-header_title slds-m-bottom_small'>
              <SvgIcon
                variant='utility'
                symbol='download'
                size='small'
                className='slds-m-top_small slds-m-right_small'
              />
              <div className='slds-m-top_medium'>Downloads</div>
            </div>
          </div>
          <FilterSidebar
            filters={filters}
            filtersApplied={numberOfFiltersApplied}
            onClear={this.handleFilterClear}
            search={true}
            searchString={this.state.search}
            onSearchClick={this.handleSearchClick}
            onSearchClear={this.handleSearchClear}
          />
          <div className='slds-col slds-size_10-of-12 slds-p-around_medium'>
            <Downloads
              language={this.state.languageFilter}
              search={this.state.search}
              orderBy={this.state.orderBy}
              changeSort={this.handleSortChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(DownloadList)



// WEBPACK FOOTER //
// ./src/containers/Downloads.js